import * as Tooltip from '@radix-ui/react-tooltip';
import { MessageCircle, Phone, Send } from 'lucide-react';
import React from 'react';

/**
 * Channel icons for a phone number. One number can be active on several
 * channels simultaneously, so this renders a set, not a single badge.
 *
 * Channel *codes* come from seed data (product-neutrality rule) — this map is
 * presentation only, and an unknown code degrades to a neutral icon rather
 * than breaking. It never decides which channels exist.
 */
const CHANNEL_ICONS = {
  PHONE_CALL: Phone,
  WHATSAPP: MessageCircle,
  BALE: Send,
  EITAA: Send,
  INSTAGRAM: MessageCircle,
};

export function ChannelIcons({ channels = [] }) {
  if (channels.length === 0) return <span className="text-text-muted">—</span>;

  return (
    <Tooltip.Provider delayDuration={200}>
      <span className="flex items-center gap-2">
        {channels.map((channel) => {
          const Icon = CHANNEL_ICONS[channel.code] ?? MessageCircle;
          return (
            <Tooltip.Root key={channel.id}>
              <Tooltip.Trigger asChild>
                <span className="text-text-muted">
                  <Icon size={14} aria-label={channel.labelFa} />
                </span>
              </Tooltip.Trigger>
              <Tooltip.Portal>
                <Tooltip.Content
                  dir="rtl"
                  sideOffset={4}
                  className="rounded border border-border bg-surface px-3 py-1 text-xs shadow-md"
                >
                  {channel.labelFa}
                </Tooltip.Content>
              </Tooltip.Portal>
            </Tooltip.Root>
          );
        })}
      </span>
    </Tooltip.Provider>
  );
}
